import React from 'react';
import * as ReactPropTypes from 'prop-types';
import { omitBy, isUndefined } from 'lodash';

import { fetchingStatus } from 'helpers/redux';
import { Interval } from 'helpers/date';

export const PropTypes = {
  ...ReactPropTypes,

  children: ReactPropTypes.node,

  // redux-form
  inputShape: ReactPropTypes.shape({
    name: ReactPropTypes.string,
    onBlur: ReactPropTypes.func,
    onChange: ReactPropTypes.func,
    onDragStart: ReactPropTypes.func,
    onDrop: ReactPropTypes.func,
    onFocus: ReactPropTypes.func,
    value: ReactPropTypes.any
  }),
  metaShape: ReactPropTypes.shape({
    touched: ReactPropTypes.bool,
    error: ReactPropTypes.string,
    warning: ReactPropTypes.string
  }),

  // react-router
  routerShape: ReactPropTypes.shape({
    push: ReactPropTypes.func,
    isActive: ReactPropTypes.func,
    goBack: ReactPropTypes.func
    // etc
  }),

  fetchingStatusEnum: ReactPropTypes.oneOf(Object.values(fetchingStatus)),

  interval: ReactPropTypes.instanceOf(Interval),

  wizardConfigShape: ReactPropTypes.shape({
    model: ReactPropTypes.shape({
      fields: ReactPropTypes.objectOf(ReactPropTypes.string).isRequired,
      requiredFields: ReactPropTypes.arrayOf(ReactPropTypes.string).isRequired,
      initialValues: ReactPropTypes.objectOf(ReactPropTypes.any).isRequired,
      validate: ReactPropTypes.func.isRequired
    }).isRequired,
    steps: ReactPropTypes.arrayOf(
      ReactPropTypes.shape({
        path: ReactPropTypes.string.isRequired,
        label: ReactPropTypes.string.isRequired,
        fields: ReactPropTypes.array.isRequired
      })
    ).isRequired
  }),

  engineClassShape: ReactPropTypes.shape({
    name: ReactPropTypes.string,
    iconClass: ReactPropTypes.string,
    description: ReactPropTypes.string
  }),

  userInfoShape: ReactPropTypes.shape({
    phoneNumber: ReactPropTypes.string,
    mobileNumber: ReactPropTypes.string,
    companyName: ReactPropTypes.string,
    companyUrl: ReactPropTypes.string,
    companyDescription: ReactPropTypes.string,
    companyAddress: ReactPropTypes.string,
    companySuiteApt: ReactPropTypes.string,
    companyCity: ReactPropTypes.string,
    companyState: ReactPropTypes.string,
    companyZipCode: ReactPropTypes.string,
    companyCountry: ReactPropTypes.string
  })
};

export function injectInto(children, props) {
  let newProps = { ...props };
  return React.Children.map(children, (child, index) => {
    if (props.hasOwnProperty('data_row') && index === 0) {
      newProps = { ...props, ...{ style: { padding: '4px 24px 4px 24px' } } };
    }
    return React.cloneElement(child, newProps);
  });
}

// <Thing
//   { ...maybeProp(
//     'icon',
//     <WarningIcon color="red" />,
//     stepsWithSubmitErrors.includes(step.path))
//   }
// >
export function maybeProp(prop, value, condition) {
  return omitBy(
    {
      [prop]: condition ? value : undefined
    },
    isUndefined
  );
}



// WEBPACK FOOTER //
// ./src/client/helpers/react/index.js